import { render, staticRenderFns } from "./GlobalNavigation.vue?vue&type=template&id=13217f0f"
import script from "./GlobalNavigation.vue?vue&type=script&lang=ts"
export * from "./GlobalNavigation.vue?vue&type=script&lang=ts"
import style0 from "./GlobalNavigation.vue?vue&type=style&index=0&id=13217f0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports